const data = {
    id: 1,
    title: 'Listen and fill the blanks to make the correct words',
    subTitle: 'Nghe và điền vào chỗ trống để tạo từ đúng',
    question: 'bear',
    filterVowels: false,
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/11c5fedf-cd9e-426b-810f-85aaba584272.mp3',
};
  
export default data;